import Vue from 'vue';
import {isNil} from 'lodash';
import {setDefaultInputsValues} from './common/setDefaultInputs';
import {v4} from 'uuid';

function getInitState() {
  return {
    saved: false,
    pendingSave: false,
    sectionId: 4,
    inputs: {
      additionalQuestions: {
        value: null,
      },
    },
    priorityAdditionalQuestions: null,
    translateAdditionalQuestions: false,
  };
}

export default {
  namespaced: true,
  state: getInitState(),
  actions: {
    setSectionErrors() {},
  },
  mutations: {
    resetState(state) {
      Object.assign(state, getInitState())
    },
    setProperty(state, [key, value]) {
      if (!state.hasOwnProperty(key)) return

      Vue.set(state, key, value)
    },
    setInputValue(state, [key, value]) {
      Vue.set(state.inputs[key], 'value', value)
    },
    setDefaultInputsValues,
    setInputsAll(state, data) {
      const sectionData = data[4]

      for (const key in state.inputs) {
        const inputObj = state.inputs[key]

        if (isNil(sectionData[key])) return;

        if (key === 'additionalQuestions') {
          const arr = sectionData[key] || [];

          const result = arr.map(q => {
            const answerVariants = q.answerVariants.map(v => {
              const tempId = v.tempId || v4();
              return { tempId, ...v };
            });
            return { ...q, answerVariants };
          });

          return Vue.set(inputObj, 'value', result);
        }

        Vue.set(inputObj, 'value', sectionData[key]);
      }
    },
  },
  getters: {
    // TODO temp comment, use for tooltip progress
    // complete(state) {
    //   let mustFilledCount = 0
    //   let filledCount = 0
    //
    //   mustFilledCount++
    //   if (state.photoAndVideoFiles.length > 0) {
    //     filledCount++
    //   }
    //   const inputs = state.inputs
    //
    //   const result = getInputsComplete(state, inputs)
    //   mustFilledCount += result.mustFilledCount
    //   filledCount += result.filledCount
    //
    //   return Math.round(100 / mustFilledCount * filledCount)
    // },
    sendData(state) {
      return {
        additionalQuestions: state.priorityAdditionalQuestions || state.inputs.additionalQuestions.value,
      };
    },
  },
};
